exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chart-options{padding:20px 30px;text-align:center}.chart-options .y-axis-option{width:60px;margin-right:10px}.chart-options label{margin-right:20px;cursor:pointer}.chart-options label input[type=checkbox]{margin-right:5px}.chart-options label span{padding-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6b8bb401!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChartComponent.vue
// module id = 827
// module chunks = 2